import { $autocompletePromise as Hr, $mapPromise as at, $markerPromise as Mr, $circleShapePromise as Cr, $clusterPromise as Nr, $drawingManagerPromise as Ur, $heatmapLayerPromise as qr, $infoWindowPromise as Wr, $kmlLayerPromise as Jr, $polygonShapePromise as Ir, $polylineShapePromise as Yr, $rectangleShapePromise as Zr, $streetViewPanoramaPromise as Xr } from "./keys.es.js";
import { watch as te, reactive as Qr, getCurrentInstance as Gr, nextTick as st, ref as Vr } from "vue";
var de = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function kr(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var he = { exports: {} };
he.exports;
(function(r, n) {
  var s = 200, a = "__lodash_hash_undefined__", u = 1, l = 2, c = 9007199254740991, d = "[object Arguments]", y = "[object Array]", j = "[object AsyncFunction]", Y = "[object Boolean]", E = "[object Date]", Z = "[object Error]", X = "[object Function]", B = "[object GeneratorFunction]", S = "[object Map]", Q = "[object Number]", ct = "[object Null]", W = "[object Object]", Le = "[object Promise]", lt = "[object Proxy]", xe = "[object RegExp]", re = "[object Set]", ze = "[object String]", dt = "[object Symbol]", ht = "[object Undefined]", be = "[object WeakMap]", je = "[object ArrayBuffer]", ne = "[object DataView]", gt = "[object Float32Array]", mt = "[object Float64Array]", _t = "[object Int8Array]", pt = "[object Int16Array]", wt = "[object Int32Array]", bt = "[object Uint8Array]", yt = "[object Uint8ClampedArray]", vt = "[object Uint16Array]", Pt = "[object Uint32Array]", Tt = /[\\^$.*+?()[\]{}|]/g, At = /^\[object .+?Constructor\]$/, Et = /^(?:0|[1-9]\d*)$/, h = {};
  h[gt] = h[mt] = h[_t] = h[pt] = h[wt] = h[bt] = h[yt] = h[vt] = h[Pt] = !0, h[d] = h[y] = h[je] = h[Y] = h[ne] = h[E] = h[Z] = h[X] = h[S] = h[Q] = h[W] = h[xe] = h[re] = h[ze] = h[be] = !1;
  var Be = typeof de == "object" && de && de.Object === Object && de, St = typeof self == "object" && self && self.Object === Object && self, L = Be || St || Function("return this")(), De = n && !n.nodeType && n, Re = De && !0 && r && !r.nodeType && r, Fe = Re && Re.exports === De, ye = Fe && Be.process, He = function() {
    try {
      return ye && ye.binding && ye.binding("util");
    } catch {
    }
  }(), Me = He && He.isTypedArray;
  function Ot(e, t) {
    for (var i = -1, o = e == null ? 0 : e.length, g = 0, f = []; ++i < o; ) {
      var _ = e[i];
      t(_, i, e) && (f[g++] = _);
    }
    return f;
  }
  function $t(e, t) {
    for (var i = -1, o = t.length, g = e.length; ++i < o; )
      e[g + i] = t[i];
    return e;
  }
  function Lt(e, t) {
    for (var i = -1, o = e == null ? 0 : e.length; ++i < o; )
      if (t(e[i], i, e))
        return !0;
    return !1;
  }
  function xt(e, t) {
    for (var i = -1, o = Array(e); ++i < e; )
      o[i] = t(i);
    return o;
  }
  function zt(e) {
    return function(t) {
      return e(t);
    };
  }
  function jt(e, t) {
    return e.has(t);
  }
  function Bt(e, t) {
    return e == null ? void 0 : e[t];
  }
  function Dt(e) {
    var t = -1, i = Array(e.size);
    return e.forEach(function(o, g) {
      i[++t] = [g, o];
    }), i;
  }
  function Rt(e, t) {
    return function(i) {
      return e(t(i));
    };
  }
  function Ft(e) {
    var t = -1, i = Array(e.size);
    return e.forEach(function(o) {
      i[++t] = o;
    }), i;
  }
  var Ht = Array.prototype, Mt = Function.prototype, ie = Object.prototype, ve = L["__core-js_shared__"], Ce = Mt.toString, $ = ie.hasOwnProperty, Ne = function() {
    var e = /[^.]+$/.exec(ve && ve.keys && ve.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }(), Ue = ie.toString, Ct = RegExp(
    "^" + Ce.call($).replace(Tt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), qe = Fe ? L.Buffer : void 0, ae = L.Symbol, We = L.Uint8Array, Je = ie.propertyIsEnumerable, Nt = Ht.splice, H = ae ? ae.toStringTag : void 0, Ie = Object.getOwnPropertySymbols, Ut = qe ? qe.isBuffer : void 0, qt = Rt(Object.keys, Object), Pe = J(L, "DataView"), G = J(L, "Map"), Te = J(L, "Promise"), Ae = J(L, "Set"), Ee = J(L, "WeakMap"), V = J(Object, "create"), Wt = N(Pe), Jt = N(G), It = N(Te), Yt = N(Ae), Zt = N(Ee), Ye = ae ? ae.prototype : void 0, Se = Ye ? Ye.valueOf : void 0;
  function M(e) {
    var t = -1, i = e == null ? 0 : e.length;
    for (this.clear(); ++t < i; ) {
      var o = e[t];
      this.set(o[0], o[1]);
    }
  }
  function Xt() {
    this.__data__ = V ? V(null) : {}, this.size = 0;
  }
  function Qt(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }
  function Gt(e) {
    var t = this.__data__;
    if (V) {
      var i = t[e];
      return i === a ? void 0 : i;
    }
    return $.call(t, e) ? t[e] : void 0;
  }
  function Vt(e) {
    var t = this.__data__;
    return V ? t[e] !== void 0 : $.call(t, e);
  }
  function kt(e, t) {
    var i = this.__data__;
    return this.size += this.has(e) ? 0 : 1, i[e] = V && t === void 0 ? a : t, this;
  }
  M.prototype.clear = Xt, M.prototype.delete = Qt, M.prototype.get = Gt, M.prototype.has = Vt, M.prototype.set = kt;
  function x(e) {
    var t = -1, i = e == null ? 0 : e.length;
    for (this.clear(); ++t < i; ) {
      var o = e[t];
      this.set(o[0], o[1]);
    }
  }
  function Kt() {
    this.__data__ = [], this.size = 0;
  }
  function er(e) {
    var t = this.__data__, i = oe(t, e);
    if (i < 0)
      return !1;
    var o = t.length - 1;
    return i == o ? t.pop() : Nt.call(t, i, 1), --this.size, !0;
  }
  function tr(e) {
    var t = this.__data__, i = oe(t, e);
    return i < 0 ? void 0 : t[i][1];
  }
  function rr(e) {
    return oe(this.__data__, e) > -1;
  }
  function nr(e, t) {
    var i = this.__data__, o = oe(i, e);
    return o < 0 ? (++this.size, i.push([e, t])) : i[o][1] = t, this;
  }
  x.prototype.clear = Kt, x.prototype.delete = er, x.prototype.get = tr, x.prototype.has = rr, x.prototype.set = nr;
  function C(e) {
    var t = -1, i = e == null ? 0 : e.length;
    for (this.clear(); ++t < i; ) {
      var o = e[t];
      this.set(o[0], o[1]);
    }
  }
  function ir() {
    this.size = 0, this.__data__ = {
      hash: new M(),
      map: new (G || x)(),
      string: new M()
    };
  }
  function ar(e) {
    var t = ue(this, e).delete(e);
    return this.size -= t ? 1 : 0, t;
  }
  function sr(e) {
    return ue(this, e).get(e);
  }
  function or(e) {
    return ue(this, e).has(e);
  }
  function ur(e, t) {
    var i = ue(this, e), o = i.size;
    return i.set(e, t), this.size += i.size == o ? 0 : 1, this;
  }
  C.prototype.clear = ir, C.prototype.delete = ar, C.prototype.get = sr, C.prototype.has = or, C.prototype.set = ur;
  function se(e) {
    var t = -1, i = e == null ? 0 : e.length;
    for (this.__data__ = new C(); ++t < i; )
      this.add(e[t]);
  }
  function fr(e) {
    return this.__data__.set(e, a), this;
  }
  function cr(e) {
    return this.__data__.has(e);
  }
  se.prototype.add = se.prototype.push = fr, se.prototype.has = cr;
  function D(e) {
    var t = this.__data__ = new x(e);
    this.size = t.size;
  }
  function lr() {
    this.__data__ = new x(), this.size = 0;
  }
  function dr(e) {
    var t = this.__data__, i = t.delete(e);
    return this.size = t.size, i;
  }
  function hr(e) {
    return this.__data__.get(e);
  }
  function gr(e) {
    return this.__data__.has(e);
  }
  function mr(e, t) {
    var i = this.__data__;
    if (i instanceof x) {
      var o = i.__data__;
      if (!G || o.length < s - 1)
        return o.push([e, t]), this.size = ++i.size, this;
      i = this.__data__ = new C(o);
    }
    return i.set(e, t), this.size = i.size, this;
  }
  D.prototype.clear = lr, D.prototype.delete = dr, D.prototype.get = hr, D.prototype.has = gr, D.prototype.set = mr;
  function _r(e, t) {
    var i = fe(e), o = !i && zr(e), g = !i && !o && Oe(e), f = !i && !o && !g && tt(e), _ = i || o || g || f, p = _ ? xt(e.length, String) : [], w = p.length;
    for (var m in e)
      (t || $.call(e, m)) && !(_ && // Safari 9 has enumerable `arguments.length` in strict mode.
      (m == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      g && (m == "offset" || m == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      f && (m == "buffer" || m == "byteLength" || m == "byteOffset") || // Skip index properties.
      Sr(m, w))) && p.push(m);
    return p;
  }
  function oe(e, t) {
    for (var i = e.length; i--; )
      if (Ve(e[i][0], t))
        return i;
    return -1;
  }
  function pr(e, t, i) {
    var o = t(e);
    return fe(e) ? o : $t(o, i(e));
  }
  function k(e) {
    return e == null ? e === void 0 ? ht : ct : H && H in Object(e) ? Ar(e) : xr(e);
  }
  function Ze(e) {
    return K(e) && k(e) == d;
  }
  function Xe(e, t, i, o, g) {
    return e === t ? !0 : e == null || t == null || !K(e) && !K(t) ? e !== e && t !== t : wr(e, t, i, o, Xe, g);
  }
  function wr(e, t, i, o, g, f) {
    var _ = fe(e), p = fe(t), w = _ ? y : R(e), m = p ? y : R(t);
    w = w == d ? W : w, m = m == d ? W : m;
    var P = w == W, O = m == W, b = w == m;
    if (b && Oe(e)) {
      if (!Oe(t))
        return !1;
      _ = !0, P = !1;
    }
    if (b && !P)
      return f || (f = new D()), _ || tt(e) ? Qe(e, t, i, o, g, f) : Pr(e, t, w, i, o, g, f);
    if (!(i & u)) {
      var T = P && $.call(e, "__wrapped__"), A = O && $.call(t, "__wrapped__");
      if (T || A) {
        var F = T ? e.value() : e, z = A ? t.value() : t;
        return f || (f = new D()), g(F, z, i, o, f);
      }
    }
    return b ? (f || (f = new D()), Tr(e, t, i, o, g, f)) : !1;
  }
  function br(e) {
    if (!et(e) || $r(e))
      return !1;
    var t = ke(e) ? Ct : At;
    return t.test(N(e));
  }
  function yr(e) {
    return K(e) && Ke(e.length) && !!h[k(e)];
  }
  function vr(e) {
    if (!Lr(e))
      return qt(e);
    var t = [];
    for (var i in Object(e))
      $.call(e, i) && i != "constructor" && t.push(i);
    return t;
  }
  function Qe(e, t, i, o, g, f) {
    var _ = i & u, p = e.length, w = t.length;
    if (p != w && !(_ && w > p))
      return !1;
    var m = f.get(e);
    if (m && f.get(t))
      return m == t;
    var P = -1, O = !0, b = i & l ? new se() : void 0;
    for (f.set(e, t), f.set(t, e); ++P < p; ) {
      var T = e[P], A = t[P];
      if (o)
        var F = _ ? o(A, T, P, t, e, f) : o(T, A, P, e, t, f);
      if (F !== void 0) {
        if (F)
          continue;
        O = !1;
        break;
      }
      if (b) {
        if (!Lt(t, function(z, U) {
          if (!jt(b, U) && (T === z || g(T, z, i, o, f)))
            return b.push(U);
        })) {
          O = !1;
          break;
        }
      } else if (!(T === A || g(T, A, i, o, f))) {
        O = !1;
        break;
      }
    }
    return f.delete(e), f.delete(t), O;
  }
  function Pr(e, t, i, o, g, f, _) {
    switch (i) {
      case ne:
        if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
          return !1;
        e = e.buffer, t = t.buffer;
      case je:
        return !(e.byteLength != t.byteLength || !f(new We(e), new We(t)));
      case Y:
      case E:
      case Q:
        return Ve(+e, +t);
      case Z:
        return e.name == t.name && e.message == t.message;
      case xe:
      case ze:
        return e == t + "";
      case S:
        var p = Dt;
      case re:
        var w = o & u;
        if (p || (p = Ft), e.size != t.size && !w)
          return !1;
        var m = _.get(e);
        if (m)
          return m == t;
        o |= l, _.set(e, t);
        var P = Qe(p(e), p(t), o, g, f, _);
        return _.delete(e), P;
      case dt:
        if (Se)
          return Se.call(e) == Se.call(t);
    }
    return !1;
  }
  function Tr(e, t, i, o, g, f) {
    var _ = i & u, p = Ge(e), w = p.length, m = Ge(t), P = m.length;
    if (w != P && !_)
      return !1;
    for (var O = w; O--; ) {
      var b = p[O];
      if (!(_ ? b in t : $.call(t, b)))
        return !1;
    }
    var T = f.get(e);
    if (T && f.get(t))
      return T == t;
    var A = !0;
    f.set(e, t), f.set(t, e);
    for (var F = _; ++O < w; ) {
      b = p[O];
      var z = e[b], U = t[b];
      if (o)
        var rt = _ ? o(U, z, b, t, e, f) : o(z, U, b, e, t, f);
      if (!(rt === void 0 ? z === U || g(z, U, i, o, f) : rt)) {
        A = !1;
        break;
      }
      F || (F = b == "constructor");
    }
    if (A && !F) {
      var ce = e.constructor, le = t.constructor;
      ce != le && "constructor" in e && "constructor" in t && !(typeof ce == "function" && ce instanceof ce && typeof le == "function" && le instanceof le) && (A = !1);
    }
    return f.delete(e), f.delete(t), A;
  }
  function Ge(e) {
    return pr(e, Dr, Er);
  }
  function ue(e, t) {
    var i = e.__data__;
    return Or(t) ? i[typeof t == "string" ? "string" : "hash"] : i.map;
  }
  function J(e, t) {
    var i = Bt(e, t);
    return br(i) ? i : void 0;
  }
  function Ar(e) {
    var t = $.call(e, H), i = e[H];
    try {
      e[H] = void 0;
      var o = !0;
    } catch {
    }
    var g = Ue.call(e);
    return o && (t ? e[H] = i : delete e[H]), g;
  }
  var Er = Ie ? function(e) {
    return e == null ? [] : (e = Object(e), Ot(Ie(e), function(t) {
      return Je.call(e, t);
    }));
  } : Rr, R = k;
  (Pe && R(new Pe(new ArrayBuffer(1))) != ne || G && R(new G()) != S || Te && R(Te.resolve()) != Le || Ae && R(new Ae()) != re || Ee && R(new Ee()) != be) && (R = function(e) {
    var t = k(e), i = t == W ? e.constructor : void 0, o = i ? N(i) : "";
    if (o)
      switch (o) {
        case Wt:
          return ne;
        case Jt:
          return S;
        case It:
          return Le;
        case Yt:
          return re;
        case Zt:
          return be;
      }
    return t;
  });
  function Sr(e, t) {
    return t = t ?? c, !!t && (typeof e == "number" || Et.test(e)) && e > -1 && e % 1 == 0 && e < t;
  }
  function Or(e) {
    var t = typeof e;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
  }
  function $r(e) {
    return !!Ne && Ne in e;
  }
  function Lr(e) {
    var t = e && e.constructor, i = typeof t == "function" && t.prototype || ie;
    return e === i;
  }
  function xr(e) {
    return Ue.call(e);
  }
  function N(e) {
    if (e != null) {
      try {
        return Ce.call(e);
      } catch {
      }
      try {
        return e + "";
      } catch {
      }
    }
    return "";
  }
  function Ve(e, t) {
    return e === t || e !== e && t !== t;
  }
  var zr = Ze(/* @__PURE__ */ function() {
    return arguments;
  }()) ? Ze : function(e) {
    return K(e) && $.call(e, "callee") && !Je.call(e, "callee");
  }, fe = Array.isArray;
  function jr(e) {
    return e != null && Ke(e.length) && !ke(e);
  }
  var Oe = Ut || Fr;
  function Br(e, t) {
    return Xe(e, t);
  }
  function ke(e) {
    if (!et(e))
      return !1;
    var t = k(e);
    return t == X || t == B || t == j || t == lt;
  }
  function Ke(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= c;
  }
  function et(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  function K(e) {
    return e != null && typeof e == "object";
  }
  var tt = Me ? zt(Me) : yr;
  function Dr(e) {
    return jr(e) ? _r(e) : vr(e);
  }
  function Rr() {
    return [];
  }
  function Fr() {
    return !1;
  }
  r.exports = Br;
})(he, he.exports);
var Kr = he.exports;
const we = /* @__PURE__ */ kr(Kr);
function ge(r) {
  return r.charAt(0).toUpperCase() + r.slice(1);
}
function nt(r, n) {
  return n ? Object.keys(r).reduce(
    (s, a) => (a !== "options" && !/^(\w+)(key)$/gim.test(a) && (n == null ? void 0 : n.$props)[a] != null && (s[a] = (n == null ? void 0 : n.$props)[a]), s),
    {}
  ) : Object.keys(r).reduce(
    (s, a) => (a !== "options" && !/^(\w+)(key)$/gim.test(a) && r[a] != null && (s[a] = r[a]), s),
    {}
  );
}
function en(r) {
  let n = !1, s;
  return () => (n || (n = !0, s = r()), s);
}
function _n(r) {
  return Object.entries(r).map(([n, s]) => {
    const a = {};
    return "type" in s && (a.type = s.type), "default" in s && (a.default = s.default), "required" in s && (a.required = s.required), [n, a];
  }).reduce(
    (n, [s, a]) => (n[s] = a, n),
    {}
  );
}
function pn(r) {
  if (!r)
    throw new Error(
      `The input for downArrowSimulator should be defined, currently: ${r}`
    );
  const n = it(r) ? r.attachEvent : r.addEventListener;
  function s(a, u) {
    if (a === "keydown") {
      const l = u;
      u = (c) => {
        const d = document.getElementsByClassName("pac-item-selected").length > 0;
        if (c.key === "Enter" && c.code === "Enter" && !d) {
          const y = new KeyboardEvent("keydown", {
            key: "ArrowDown",
            code: "ArrowDown",
            keyCode: 40,
            which: 40
          });
          l.apply(r, [y]);
        }
        l.apply(r, [c]);
      };
    }
    n.apply(r, [a, u]);
  }
  r.addEventListener = s, it(r) && (r.attachEvent = s);
}
function wn(r) {
  let n = 0;
  r(
    () => {
      n += 1;
    },
    () => {
      n = Math.max(0, n - 1);
    },
    () => n === 0
  );
}
function bn(r, n, s, a = !1) {
  let u = !1;
  function l() {
    u || (u = !0, s.$nextTick(() => {
      u = !1, n();
    }));
  }
  r.forEach((c) => {
    s.$watch(c, l, { immediate: a });
  });
}
function ot(r, n, s, a = !1) {
  let u = !1;
  function l(c, d) {
    u || (u = !0, st(() => {
      u = !1, c && !we(c, d) && n();
    }));
  }
  r.forEach((c) => {
    te(() => s[c], l, { immediate: a });
  });
}
function tn(r, n, s, a = []) {
  r.forEach((u) => {
    !a.includes(u) && !/_changed/.test(u) && n.addListener(u, (l) => {
      s.$emit(u, l);
    });
  });
}
function rn(r, n, s) {
  Object.entries(s.$props).forEach(([a, u]) => {
    var l;
    if (!r.noBind.includes(a)) {
      const c = `set${ge(a)}`, d = `get${ge(a)}`, y = `${a.toLowerCase()}_changed`;
      n[c] && typeof n[c] == "function" && (typeof u != "object" && !Array.isArray(u) || !((l = r.trackProperties[a]) != null && l.length) ? te(
        // TODO: confirm this watch works, because I think it needs the variable not only the name of the variable
        () => a,
        () => {
          n[c](u);
        },
        {
          immediate: u != null,
          deep: typeof u != "object" && !Array.isArray(u)
        }
      ) : ot(
        r.trackProperties[a].map(
          (j) => `${a}.${j}`
        ),
        () => {
          n[c](u);
        },
        s.$props,
        u != null
      )), r.twoWay.includes(a) && n[d] && typeof n[d] == "function" && (n == null || n.addListener(y, () => {
        const j = n[d]();
        j && !we(j, s.$props[a]) && s.$emit(
          y,
          n[d]()
        );
      }));
    }
  });
}
function yn(r, n, s, a = []) {
  r.forEach((u) => {
    !a.includes(u) && !/_changed/.test(u) && (n == null || n.addListener(u, (l) => {
      s(u, l);
    }));
  });
}
function vn(r, n, s, a) {
  Object.keys(a).forEach((u) => {
    if (!r.noBind.includes(u)) {
      const { eventName: l, getMethodName: c } = sn(
        u,
        a,
        r.trackProperties[u],
        n
      );
      r.twoWay.includes(u) && n[c] && typeof n[c] == "function" && (n == null || n.addListener(l, () => {
        const d = n[c]();
        d && !we(d, a[u]) && s(l, d);
      }));
    }
  });
}
function nn() {
  return Qr({
    resolve: void 0,
    reject: void 0
  });
}
function an(r) {
  return new Promise((n, s) => {
    r.resolve = n, r.reject = s;
  });
}
function Pn(r) {
  let n, s;
  function a(l) {
    const c = l == null ? void 0 : l.parent, d = (c == null ? void 0 : c.type.name) || (c == null ? void 0 : c.type.__name);
    return { ancestor: c, name: d };
  }
  const u = Gr();
  for ({ ancestor: n, name: s } = a(u); n && s !== r; )
    ({ ancestor: n, name: s } = a(n));
  return n;
}
function sn(r, n, s, a) {
  const u = `set${ge(r)}`, l = `get${ge(r)}`, c = `${r.toLowerCase()}_changed`;
  return a[u] && typeof a[u] == "function" && (typeof n[r] != "object" && !Array.isArray(n[r]) || !(s != null && s.length) ? te(
    () => n[r],
    (d, y) => {
      d != null && !we(d, y) && a[u](d);
    },
    {
      immediate: n[r] != null,
      deep: typeof n[r] != "object" && !Array.isArray(n[r])
    }
  ) : ot(
    s.map((d) => `${r}.${d}`),
    () => {
      a[u](n[r]);
    },
    n,
    n[r] != null
  )), { eventName: c, getMethodName: l };
}
function it(r) {
  return r.attachEvent !== void 0;
}
const me = /* @__PURE__ */ new Map(), _e = /* @__PURE__ */ new Map();
function ut(r) {
  const n = nn(), s = an(n);
  me.set(r, n), _e.set(r, s);
}
function v(r) {
  return _e.has(r) || ut(r), _e.get(r);
}
function on(r) {
  return me.has(r) || ut(r), me.get(r);
}
function Tn(r) {
  const n = on(r), s = v(r);
  return { promiseDeferred: n, promise: s };
}
function An(r) {
  _e.delete(r), me.delete(r);
}
function En(r = Hr) {
  return v(r);
}
function un(r = at) {
  return v(r);
}
function Sn(r = Mr) {
  return v(r);
}
function On(r = Cr) {
  return v(r);
}
function $n(r = Nr) {
  return v(r);
}
function Ln(r = Ur) {
  return v(r);
}
function xn(r = qr) {
  return v(r);
}
function zn(r = Wr) {
  return v(r);
}
function jn(r = Jr) {
  return v(r);
}
function Bn(r = Ir) {
  return v(r);
}
function Dn(r = Yr) {
  return v(r);
}
function Rn(r = Zr) {
  return v(r);
}
function Fn(r = Xr) {
  return v(r);
}
function fn() {
  let r = !1;
  return (n) => {
    if (Array.isArray(n) || typeof n != "object")
      throw new Error("options should  be an object");
    if (typeof document > "u")
      return;
    const s = { ...n }, { libraries: a } = s;
    if (s.callback = "GoogleMapsCallback", Array.isArray(a) && (s.libraries = a.join(",")), r)
      window.console.info("You already started the loading of google maps");
    else {
      r = !0;
      const u = document.createElement("script");
      u.setAttribute("type", "text/javascript"), u.innerHTML = `
      ((g) => {
        var h,
          a,
          k,
          p = 'The Google Maps JavaScript API',
          c = 'google',
          l = 'importLibrary',
          q = '__ib__',
          m = document,
          b = window;
        b = b[c] || (b[c] = {});
        var d = b.maps || (b.maps = {}),
          r = new Set(),
          e = new URLSearchParams(),
          u = () =>
            h ||
            (h = new Promise(async (f, n) => {
              await (a = m.createElement('script'));
              e.set('libraries', [...r] + '');
              for (k in g)
                e.set(
                  k.replace(/[A-Z]/g, (t) => '_' + t[0].toLowerCase()),
                  g[k]
                );
              e.set('callback', c + '.maps.' + q);
              a.src = \`https://maps.\${c}apis.com/maps/api/js?\` + e;
              d[q] = f;
              a.onerror = () => (h = n(Error(p + ' could not load.')));
              a.nonce = m.querySelector('script[nonce]')?.nonce || '';
              m.head.append(a);
            }));
        d[l]
          ? console.warn(p + ' only loads once. Ignoring:', g)
          : (d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)));
      })(${JSON.stringify(s)});`, document.head.appendChild(u);
    }
  };
}
const Hn = fn();
function cn(r, n) {
  if (!r)
    throw new Error(n);
}
function Mn(r) {
  const {
    mappedProps: n,
    name: s,
    ctr: a,
    ctrArgs: u,
    events: l,
    beforeCreate: c,
    afterCreate: d,
    props: y,
    ...j
  } = r, Y = `$${s}Promise`, E = `$${s}Object`;
  return cn(!(y instanceof Array), "`props` should be an object, not Array"), {
    props: {
      ...y
    },
    async setup() {
    },
    render() {
      return "";
    },
    provide() {
      var X;
      const Z = (X = un(at)) == null ? void 0 : X.then((B) => {
        if (!B)
          throw new Error("the map instance is not defined");
        this.$map = B;
        const S = {
          map: B,
          ...nt(y, this),
          ...this.options
        };
        if (c) {
          const Q = c.bind(this)(S);
          if (Q instanceof Promise)
            return Q.then(() => ({ options: S }));
        }
        return { options: S };
      }).then(({ options: B }) => {
        const S = a();
        return this[E] = u ? new (Function.prototype.bind.call(
          S,
          null,
          ...u(
            B,
            nt(y || {}, this)
          )
        ))() : new S(B), rn(n, this[E], this), tn(l, this[E], this), d && d.bind(this)(this[E]), this[E];
      });
      return this[Y] = Z, { [Y]: Z };
    },
    destroyed() {
      this[E] && this[E].setMap && this[E].setMap(null);
    },
    ...j
  };
}
let pe, I;
function Cn(r, n) {
  return (s) => {
    function a() {
      return n.isReady = !0, globalThis.google;
    }
    return en(
      () => dn(s, r, a)
    );
  };
}
function ln(r) {
  let n = !1;
  globalThis.GoogleMapsCallback = () => {
    try {
      r();
    } catch (a) {
      globalThis.console.error("Error executing the GoogleMapsCallback", a);
    } finally {
      n = !0;
    }
  };
  let s = window.setTimeout(() => {
    let a = window.setInterval(() => {
      var u;
      s && (globalThis.clearTimeout(s), s = void 0), ((u = window == null ? void 0 : window.google) == null ? void 0 : u.maps) != null && !n && globalThis.GoogleMapsCallback(), n && (clearInterval(a), a = void 0);
    }, 500);
  }, 1e3);
}
function dn(r, n, s) {
  return new Promise((a, u) => {
    if (!(typeof window > "u"))
      try {
        ln(a), !r.dynamicLoad && r.load && n(r.load);
      } catch (l) {
        u(l);
      }
  }).then(s);
}
function Nn(r, n) {
  pe || (pe = r), I || (I = n);
}
function Un() {
  return I || globalThis.console.warn("$googleMapsApiPromiseLazy was not created yet..."), I == null ? void 0 : I();
}
function qn() {
  return pe || globalThis.console.warn("$finalOptions was not defined yet..."), pe;
}
function hn(r) {
  return { all: r = r || /* @__PURE__ */ new Map(), on: function(n, s) {
    var a = r.get(n);
    a ? a.push(s) : r.set(n, [s]);
  }, off: function(n, s) {
    var a = r.get(n);
    a && (s ? a.splice(a.indexOf(s) >>> 0, 1) : r.set(n, []));
  }, emit: function(n, s) {
    var a = r.get(n);
    a && a.slice().map(function(u) {
      u(s);
    }), (a = r.get("*")) && a.slice().map(function(u) {
      u(n, s);
    });
  } };
}
const ft = hn(), q = Vr();
let $e, ee;
function Wn(r, n) {
  r.resizeBus || (q.value = ft), r.resizeBus && (q.value = r.resizeBus), $e = () => {
    n();
  }, ee = () => st(() => $e()), te(
    () => r.resizeBus,
    (s) => {
      q.value = s.value;
    }
  ), te(
    () => q,
    (s, a) => {
      a.value && a.value.off("resize", ee), s.value && s.value.on("resize", ee);
    }
  );
}
function Jn() {
  q.value && q.value.off("resize", ee);
}
function In() {
  return ft;
}
function Yn() {
  return {
    currentResizeBus: q,
    _resizeCallback: $e,
    _delayedResizeCallback: ee
  };
}
export {
  yn as A,
  vn as B,
  nn as C,
  an as D,
  Pn as E,
  Mn as F,
  Cn as G,
  Nn as H,
  Un as I,
  qn as J,
  Wn as K,
  Jn as L,
  In as M,
  Yn as N,
  we as O,
  An as a,
  En as b,
  un as c,
  Sn as d,
  On as e,
  $n as f,
  Ln as g,
  xn as h,
  zn as i,
  jn as j,
  Bn as k,
  Dn as l,
  Rn as m,
  Fn as n,
  Hn as o,
  ge as p,
  nt as q,
  en as r,
  _n as s,
  pn as t,
  Tn as u,
  wn as v,
  bn as w,
  ot as x,
  tn as y,
  rn as z
};
